import { Pipe, PipeTransform } from '@angular/core';
import { sortBy } from 'lodash';

@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

    transform<T>(value: T[], resourceToSortBy: string, descending: boolean = false): T[] {
        const sorted = sortBy(value, resourceToSortBy);
        return descending ? sorted.reverse() : sorted;
    }

}
